import { useId, type ChangeEvent } from 'react';
import { FloatingLabelInputLayout } from 'framework/ui/layout';
import type { Note } from './rangeEntry';

interface CountBoundInputProps {
  name: string;
  input: unknown;
  note: Note | undefined;
  onInput: (input: string) => void;
}

export const CountBoundInput = ({ name, input, note, onInput }: CountBoundInputProps) => {
  const inputId = useId();

  return (
    <FloatingLabelInputLayout
      source={inputId}
      label={name}
      value={typeof input === 'string' ? input : ''}
      errorMessages={note?.error ? [note.text] : []}
      helpText={note?.error ? undefined : note?.text}
      sx={{ mb: 0 }}
      slotProps={{
        inputLabel: { shrink: true },
        htmlInput: {
          placeholder: 'No limit',
          inputMode: 'numeric',
          autoComplete: 'off',
          onChange: (event: ChangeEvent<HTMLInputElement>) => onInput(event.currentTarget.value.replace(/\D/g, '')),
        },
      }}
    />
  );
};
